import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { $api } from '../../../../helpers/api'
import axios from 'axios'

export const getGuide = createAsyncThunk('get guide data', async () => {
  try {
    const result = await $api.get(`/guide`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateGuide = createAsyncThunk('update guide data', async ({ data }) => {
  try {
    const result = await $api.put(`/guide`, data)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

const initialState = {
  data: undefined,
  isLoading: false,
  error: null,
}

export const guideSlice = createSlice({
  name: 'guide',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getGuide.pending, state => {
        state.isLoading = true
        state.data = undefined
        state.error = null
      })
      .addCase(getGuide.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(getGuide.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
        state.error = action.error.message
      })
  },
})

export const { actions: guideActions } = guideSlice
export const { reducer: guideReducer } = guideSlice
